/* eslint-disable */
import getWordCount from '~/util/estimateLineCount'
import intl from 'react-intl-universal'
import styles from './styles.scss'
import CONSTANTS from '~/constants'
import { get, isNil } from 'lodash'
import { NEW_EDITOR_EXP } from '../../util/constants/keys'

export default [
  '$scope',
  'searchService',
  '$location',
  'storeService',
  '$rootScope',
  'evidentlyService',
  SearchResultsController,
]

function SearchResultsController(
  $scope,
  searchService,
  $location,
  store,
  $rootScope,
  evidentlyService
) {
  $scope.CONSTANTS = CONSTANTS
  this.intl = intl
  $scope.isIframe = !!window.frameElement

  $scope.displaySlugs =
    $scope.$parent.companySettings.displaySlugInSearchResults

  $scope.displayBudgetLine =
    $scope.$parent.companySettings.displayBudgetLineInSearchResults

  this.$onInit = async () => {
    let v2Enabled = false
    const evidentlyFlags = await evidentlyService.instance()

    const userEnabledNewEditor = window.localStorage.getItem(NEW_EDITOR_EXP)
    if ($rootScope.globalSettings?.openBeta?.enabled) {
      if (userEnabledNewEditor === undefined || userEnabledNewEditor === null) {
        v2Enabled = $rootScope.globalSettings?.openBeta?.default ?? false
      } else {
        v2Enabled = userEnabledNewEditor === 'true'
      }
    }

    if (evidentlyFlags['ui-v2-release'] && userEnabledNewEditor === null) {
      window.localStorage.setItem(NEW_EDITOR_EXP, 'true')
    }

    // TODO: Remove 'should use new editor' flag when enabling open beta
    const shouldUseNewEditor = v2Enabled || (evidentlyFlags['ui-v2-release'] && !userEnabledNewEditor)
    if (shouldUseNewEditor) {
      $scope.storyEditUrl = '/composer/story/v2/edit'
    } else {
      $scope.storyEditUrl = '/composer/edit'
    }

    if (evidentlyFlags['ui-v1-dropoff'] && !$rootScope.globalSettings?.openBeta?.legacyEnabled) {
      $scope.storyEditUrl = '/composer/story/v2/edit'
    }
  }

  this.createDateTimeFormat = (date) => {
    const newDate = new Date(date)
    const lang = window.navigator.language
    const timeZone = $scope.$parent.companySettings.timezone
      ? $scope.$parent.companySettings.timezone
      : undefined

    return new Intl.DateTimeFormat(lang, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone,
    }).format(newDate)
  }

  this.getWebsked = (story) => {
    this.webskedIsDown = this.webskedData.webskedDown
    return (
      this.hasWebSked &&
      (this.webskedData.buttons || []).find(
        (w) => w.id === (story.workflow || { status_code: 0 }).status_code
      )
    )
  }

  this.hasWebSked = !$scope.$parent.companySettings.disableWebskedIntegration

  this.displayCount = (story) => {
    const count = getWordCount(story.content_elements)
    return `${Math.ceil(count.words)}W / ${Math.ceil(
      count.inches
    )}IN / ${Math.ceil(count.lines)}LN`
  }

  // published, not published
  this.publishLabel = (story) => {
    if (story.syntheticPublishingStatus === true) {
      return intl.get('searchResults.publishLabel.published')
    } else if (story.syntheticPublishingStatus === false) {
      return intl.get('searchResults.publishLabel.notPublished')
    } else {
      return story.syntheticPublishingStatus
    }
  }

  // published date, or blank
  this.publishDate = (story) => {
    if (story.publish_date) {
      return this.createDateTimeFormat(story.publish_date)
    } else {
      return null
    }
  }

  this.modifyDate = (story) => {
    return this.createDateTimeFormat(story.last_updated_date)
  }

  this.credits = (story) => {
    const authors = (story.credits || { by: [] }).by || []
    if (authors.length < 1) {
      return intl.get('searchResults.credits.none')
    } else if (authors.length === 1) {
      const byline = get(authors[0], 'additional_properties.original.byline')
      const authorName =
        byline ||
        get(authors[0], 'name') ||
        get(authors[0], 'referent.id') ||
        intl.get('searchResults.credits.unknown')
      return authorName
    } else if (authors.length > 1) {
      const props = authors[0].additional_properties
      const byline = props && props.original && props.original.byline
      let first = byline || authors[0].name
      if (!first) {
        first = authors[0].referent
          ? authors[0].referent.id
          : intl.get('searchResults.credits.unknown')
      }
      if (first.length > 50) {
        return `${first.slice(0, 50)}... et al.`
      } else {
        return `${first} et al.`
      }
    }
  }

  this.applyClass = (item) => {
    return (
      styles.searchResults +
      ($scope.isIframe && item.isSelected ? ' bg-grey-lightest' : '')
    )
  }

  this.goToVariantEditor = (storyId, variant, $event) => {
    $event.preventDefault()
    window.open(
      `/composer/variant-editor/${storyId}/edit/${variant._id}`,
      '_blank'
    )
  }

  $scope.combineNames = (arr) => {
    return arr ? arr.map((obj) => obj.name).join(', ') : ''
  }

  // click on search result does different things
  // depending on if in iframe or not
  // has to behave same as anglerfish/goldfish
  // the click on the itemn needs to post message
  // the click on the modal to "select" just closes the iframe
  $scope.selectStoryDelegate = (evt, i) => {
    const story = this.result.content_elements[i]
    if ($scope.isIframe) {
      evt.preventDefault()
      let isSelected
      if (typeof story.isSelected === 'undefined') {
        isSelected = true
      } else {
        isSelected = !story.isSelected
      }
      this.result.content_elements[i].isSelected = isSelected
    } else {
      // $location.search({})
      // $location.path(`/story/${story._id}`)
    }
  }

  // todo: post message pubsub: we are going to have
  // many of these listeners all over the place,
  // should abstract them into a pubsub service and subscribe
  // into a single global event listener
  if ($scope.isIframe) {
    window.parent.addEventListener('message', (e) => {
      if (
        e.data === 'returnSelectedANS' &&
        this.result.content_elements.length
      ) {
        const selected = this.result.content_elements.reduce(
          (acc, story) => (story.isSelected ? [...acc, story] : acc),
          []
        )
        window &&
          window.parent &&
          window.parent.postMessage(selected, window.location.origin)
      }
    })
  }
}
